<template>
  <v-footer padless>
    <v-card flat tile class="white--text py-10" color="secondary">
      <v-row justify="space-around" align="start" class="ma-5">
        <v-col
          align-self="center"
          cols="10"
          md="3"
          class="d-flex justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40.688"
            height="72.87"
            viewBox="0 0 40.688 72.87"
          >
            <g
              id="Grupo_186"
              data-name="Grupo 186"
              transform="translate(-667 1030.788)"
            >
              <path
                id="Trazado_455"
                data-name="Trazado 455"
                d="M2.311,0H4.1V-8.75a4.256,4.256,0,0,1,4.375-4.607c2.557,0,3.842,1.436,3.842,4.238V0h1.791V-9.57c0-3.432-1.873-5.4-5.154-5.4a4.8,4.8,0,0,0-4.758,2.9H4.02v-2.652H2.311ZM18.336-11.953v2.435H16.815v1.512h1.521v5.493c0,1.837.835,2.575,2.936,2.575a6.1,6.1,0,0,0,1.028-.1v-1.5a6.225,6.225,0,0,1-.721.044c-.94,0-1.354-.448-1.354-1.477V-8.007H22.3V-9.519H20.226v-2.435Zm12.357,9.4a2.274,2.274,0,0,1-2.276,1.2c-1.512,0-2.487-1.09-2.549-2.821v-.088h6.759v-.65c0-2.988-1.608-4.808-4.271-4.808-2.7,0-4.412,1.942-4.412,4.975,0,3.05,1.679,4.939,4.421,4.939,2.188,0,3.735-1.055,4.148-2.742ZM28.347-8.191A2.352,2.352,0,0,1,30.7-5.634H25.868A2.488,2.488,0,0,1,28.347-8.191ZM43-6.478a3.776,3.776,0,0,0-4.1-3.252c-2.786,0-4.482,1.89-4.482,4.922,0,3.094,1.705,4.992,4.491,4.992,2.364,0,3.841-1.327,4.087-3.208H41.161a2.089,2.089,0,0,1-2.259,1.6c-1.573,0-2.549-1.274-2.549-3.384,0-2.065.967-3.313,2.549-3.313a2.148,2.148,0,0,1,2.259,1.644Z"
                transform="translate(664.689 -958.103)"
                fill="#1FB198"
              />
              <g
                id="Grupo_185"
                data-name="Grupo 185"
                transform="translate(641.953 -1337.856)"
              >
                <g
                  id="Grupo_145"
                  data-name="Grupo 145"
                  transform="translate(26.047 307.068)"
                >
                  <path
                    id="Trazado_359"
                    data-name="Trazado 359"
                    d="M49.267,316.593h5.446c3,0,4.194-1.056,4.194-3.7v-.824h3.272v1.215c0,5.054-2.195,7.326-6.976,7.326H50.6c-3.037,0-4.1,1.157-4.114,4.427H42.155c-.019-3.27-1.056-4.427-4.112-4.427H33.458c-4.76,0-6.934-2.272-6.934-7.326v-1.215H29.8v.824c0,2.663,1.194,3.7,4.191,3.7h5.388c2.82,0,4.368,1.549,4.681,4.6h.53C44.9,318.142,46.447,316.593,49.267,316.593Z"
                    transform="translate(-25.261 -312.068)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_360"
                    data-name="Trazado 360"
                    d="M44.586,323.311h-.53c-.312,3.055-1.861,4.6-4.681,4.6H33.988c-3,0-4.191,1.038-4.191,3.7v.823H26.524v-1.215c0-5.054,2.174-7.326,6.934-7.326h4.586c3.055,0,4.093-1.154,4.112-4.427h4.331c.019,3.273,1.078,4.427,4.114,4.427h4.6c4.782,0,6.976,2.272,6.976,7.326v1.215H58.907v-.823c0-2.645-1.194-3.7-4.194-3.7H49.267C46.447,327.915,44.9,326.366,44.586,323.311Z"
                    transform="translate(-25.261 -299.869)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_361"
                    data-name="Trazado 361"
                    d="M62.179,332.413v3.722c-3.587-2.82-11.109-5.033-17.808-5.033-6.72,0-14.244,2.213-17.847,5.033v-3.722c4.9-3.8,10.736-5.642,17.826-5.642C51.483,326.771,57.3,328.614,62.179,332.413Z"
                    transform="translate(-25.261 -287.844)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_362"
                    data-name="Trazado 362"
                    d="M40.769,350.172H37.047c2.82-3.585,5.036-11.107,5.036-17.808,0-6.72-2.216-14.241-5.036-17.847h3.723c3.8,4.9,5.642,10.736,5.642,17.829C46.411,339.476,44.569,345.3,40.769,350.172Z"
                    transform="translate(-7.924 -308.033)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_363"
                    data-name="Trazado 363"
                    d="M26.047,332.346c0-7.093,1.843-12.931,5.642-17.829h3.722c-2.822,3.606-5.036,11.128-5.036,17.847,0,6.7,2.213,14.223,5.036,17.808H31.689C27.89,345.3,26.047,339.476,26.047,332.346Z"
                    transform="translate(-26.047 -308.033)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_364"
                    data-name="Trazado 364"
                    d="M29.72,319.431a2.881,2.881,0,1,1,2.881,2.822A2.8,2.8,0,0,1,29.72,319.431Z"
                    transform="translate(-19.995 -304.583)"
                    fill="#1FB198"
                  />
                  <path
                    id="Trazado_365"
                    data-name="Trazado 365"
                    d="M34.675,319.431a2.88,2.88,0,1,1,2.881,2.822A2.8,2.8,0,0,1,34.675,319.431Z"
                    transform="translate(-11.832 -304.583)"
                    fill="#1FB198"
                  />
                </g>
              </g>
            </g>
          </svg>
        </v-col>
        <v-col cols="10" md="7">
          <v-row justify="center">
            <v-col
              id="contacto"
              cols="10"
              sm="6"
              md="3"
              class="
                d-flex
                justify-start justify-sm-start justify-md-center
                py-5
                pl-sm-5
              "
            >
              <v-list color="rgba(0,0,0,0)">
                <v-header class="white--text">{{
                  $t("nav.contacto")
                }}</v-header>
                <div class="hr accent"></div>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <a
                        class="info--text text-decoration-none"
                        href="info@ntecweb.es"
                        ><p class="pt-1">info@ntecweb.es</p></a
                      >
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col
              id="enlaces"
              cols="10"
              sm="6"
              md="3"
              class="
                d-flex
                justify-start justify-sm-end justify-md-center
                py-5
                pr-sm-15
              "
            >
              <v-list color="rgba(0,0,0,0)">
                <v-header class="white--text">{{
                  $t("info.enlaces")
                }}</v-header>
                <div class="hr accent"></div>
                <v-list-item v-for="(item, i) in enlaces" :key="i">
                  <router-link :to="item.path">
                    <v-list-item-subtitle v-t="item.name" class="info--text">
                    </v-list-item-subtitle>
                  </router-link>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col
              id="info"
              cols="10"
              sm="6"
              md="3"
              class="
                d-flex
                justify-start justify-sm-end justify-md-center
                py-5
                pl-sm-15
              "
            >
              <v-list color="rgba(0,0,0,0)">
                <v-header class="white--text">{{ $t("info.info") }}</v-header>
                <div class="hr accent"></div>
                <v-list-item v-for="(item, i) in info" :key="i">
                  <router-link :to="item.path">
                    <v-list-item-subtitle v-t="item.name" class="info--text">
                    </v-list-item-subtitle>
                  </router-link>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col
              id="atencion"
              cols="10"
              sm="6"
              md="3"
              class="
                d-flex
                justify-start justify-sm-start justify-md-center
                py-5
                pl-sm-5
              "
            >
              <v-list color="rgba(0,0,0,0)">
                <v-header class="white--text">{{
                  $t("info.atencion")
                }}</v-header>
                <div class="hr accent"></div>
                <v-list-item
                  class="info--text"
                  v-for="(item, i) in items"
                  :key="i"
                  :href="item.link"
                >
                  <v-icon v-text="item.icon" class="mr-2 info--text"></v-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle v-text="item.text" class="info--text">
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-text
        class="d-flex justify-center align-center info--text text-center"
      >
        copyright &copy; {{ new Date().getFullYear() }} powered by
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="88.248"
          height="20"
          viewBox="0 0 88.248 29.763"
        >
          <g
            id="Grupo_133"
            data-name="Grupo 133"
            transform="translate(-161.871 359.201)"
          >
            <g
              id="Grupo_130"
              data-name="Grupo 130"
              transform="translate(161.871 -359.201)"
            >
              <g id="Grupo_128" data-name="Grupo 128">
                <path
                  id="Trazado_348"
                  data-name="Trazado 348"
                  d="M169.183,538.407a17.489,17.489,0,0,0-2.891-10.176c1.306-.637,1.923-1.957,1.923-4.059v-.749H166.2v.507c0,1.63-.737,2.282-2.584,2.282h-3.356c-1.739,0-2.692.954-2.886,2.837h-.326c-.193-1.884-1.147-2.837-2.886-2.837h-3.32c-1.847,0-2.584-.64-2.584-2.282v-.507h-2.016v.749c0,2.184.66,3.524,2.064,4.131a17.515,17.515,0,0,0-2.842,10.1,17.2,17.2,0,0,0,3.372,10.846,15.949,15.949,0,0,0-2.594,1.64v2.294c2.222-1.739,6.858-3.1,11-3.1s8.765,1.364,10.975,3.1v-2.294a15.87,15.87,0,0,0-2.453-1.574A17.183,17.183,0,0,0,169.183,538.407Zm-18.764-9.721.1,0h2.825c1.883,0,2.523.712,2.535,2.728h2.668c.012-2.016.664-2.728,2.536-2.728h2.837c.1,0,.207,0,.308-.006a22.037,22.037,0,0,1,2.29,9.737q0,.193,0,.387a5.1,5.1,0,0,0-2.594-.573h-2.837c-1.871,0-2.524-.712-2.536-2.729h-2.668c-.012,2.016-.652,2.729-2.535,2.729h-2.825a5.323,5.323,0,0,0-2.381.465c0-.093,0-.186,0-.279A22.042,22.042,0,0,1,150.419,528.687Zm6.81,18.729a19.355,19.355,0,0,0-6.611,1.068,19.748,19.748,0,0,1-2.2-6.594c.307-.834,1.062-1.181,2.419-1.181h3.32c1.739,0,2.693-.954,2.886-2.837h.326c.193,1.883,1.147,2.837,2.886,2.837h3.356c1.576,0,2.341.477,2.533,1.628a19.236,19.236,0,0,1-2.151,6.2A19.262,19.262,0,0,0,157.228,547.416Z"
                  transform="translate(-145.463 -523.424)"
                  fill="#27debf"
                />
                <ellipse
                  id="Elipse_3"
                  data-name="Elipse 3"
                  cx="1.775"
                  cy="1.739"
                  rx="1.775"
                  ry="1.739"
                  transform="translate(5.994 7.412)"
                  fill="#27debf"
                />
                <ellipse
                  id="Elipse_4"
                  data-name="Elipse 4"
                  cx="1.775"
                  cy="1.739"
                  rx="1.775"
                  ry="1.739"
                  transform="translate(14.078 7.412)"
                  fill="#27debf"
                />
              </g>
            </g>
          </g>
          <path
            id="ntec"
            d="M3.961-5.535H6.369V-17.3c0-3.732,2.39-6.2,5.883-6.2,3.438,0,5.166,1.93,5.166,5.7V-5.535h2.408V-18.4c0-4.614-2.518-7.261-6.93-7.261-3.162,0-5.349,1.452-6.4,3.9H6.259v-3.566h-2.3Zm21.56-16.147v3.289H23.467v2.042h2.054v7.42c0,2.481,1.128,3.479,3.965,3.479a8.246,8.246,0,0,0,1.389-.131v-2.03a8.409,8.409,0,0,1-.974.059c-1.27,0-1.828-.605-1.828-1.995v-6.8h2.8v-2.042h-2.8v-3.289ZM42.214-8.989a3.072,3.072,0,0,1-3.075,1.615c-2.042,0-3.36-1.472-3.443-3.811V-11.3h9.13v-.879c0-4.037-2.173-6.494-5.77-6.494-3.645,0-5.96,2.624-5.96,6.72,0,4.12,2.268,6.672,5.972,6.672,2.956,0,5.046-1.425,5.6-3.7Zm-3.17-7.61c1.888,0,3.122,1.365,3.182,3.455H35.7A3.361,3.361,0,0,1,39.044-16.6Zm19.791,2.315c-.332-2.505-2.291-4.393-5.533-4.393-3.764,0-6.055,2.553-6.055,6.649,0,4.179,2.3,6.744,6.067,6.744,3.194,0,5.188-1.793,5.521-4.333H56.354A2.822,2.822,0,0,1,53.3-7.458c-2.125,0-3.443-1.722-3.443-4.571,0-2.79,1.306-4.476,3.443-4.476a2.9,2.9,0,0,1,3.051,2.22Z"
            transform="translate(29.413 30.237)"
            fill="white"
          />
        </svg>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "footer",
  data: () => ({
    enlaces: [
      {
        path: "/Proyectos",
        name: "nav.proyectos",
      },
      {
        path: "/Nosotros",
        name: "nav.nosotros",
      },
      {
        path: "/contacto",
        name: "nav.contacto",
      },
    ],
    info: [
      {
        path: "/legal",
        name: "info.aviso",
      },
      {
        path: "/Politica",
        name: "info.privacidad",
      },
      {
        path: "/coockies",
        name: "info.cookies",
      },
    ],
  }),
  computed: {
    items() {
      return [
        {
          text: "teamviewer",
          icon: "mdi-teamviewer",
          link: "https://www.teamviewer.com/es/",
        },
        {
          text: "anydesk",
          icon: "mdi-checkbox-multiple-blank mdi-rotate-225",
          link: "https://anydesk.com/es",
        },
      ];
    },
  },
};
</script>

<style scoped>
.v-card {
  width: 100%;
}

.hr {
  border-top: 2px solid;
  width: 8vw;
  margin-top: 5px;
}
</style>
